var React = require('react');
var { useEffect } = require('react');
var { useUnicornAnimation } = require('./useUnicornAnimation');
var RainbowTrail = require('./RainbowTrail');
var unicornSvg = require('./assets/unicorn.svg');

/**
 * Unicorn Component
 * Renders a single animated unicorn with rainbow trail
 *
 * @param {Object} props
 * @param {Object} props.config - Unicorn configuration
 * @param {boolean} props.isActive - Whether animation is active
 * @param {Function} props.onComplete - Callback when animation completes
 */
var Unicorn = function (props) {
  var config = props.config;
  var isActive = props.isActive;
  var onComplete = props.onComplete;

  var animationState = useUnicornAnimation(config, isActive);
  var position = animationState.position;
  var angle = animationState.angle;
  var progress = animationState.progress;
  var isComplete = animationState.isComplete;
  var prefersReducedMotion = animationState.prefersReducedMotion;

  // Notify parent when complete
  useEffect(
    function () {
      if (isComplete && onComplete) {
        onComplete(config.id);
      }
    },
    [isComplete, onComplete, config.id],
  );

  // Don't render if user prefers reduced motion
  if (prefersReducedMotion) {
    return null;
  }

  // Don't render if animation hasn't started yet (waiting for delay)
  if (progress === 0 && config.delay > 0) {
    return null;
  }

  var unicornStyle = {
    position: 'absolute',
    left: position.x - config.size / 2,
    top: position.y - config.size / 2,
    width: config.size,
    height: config.size,
    transform:
      'rotate(' +
      angle +
      'deg)' +
      (angle > 90 || angle < -90 ? ' scaleY(-1)' : ''),
    transformOrigin: 'center center',
    pointerEvents: 'none',
    willChange: 'transform, left, top',
  };

  return React.createElement(
    React.Fragment,
    null,
    // Rainbow trail
    React.createElement(RainbowTrail, {
      path: config.path,
      progress: progress,
      unicornId: config.id,
    }),
    // Unicorn image
    React.createElement('img', {
      src: unicornSvg,
      alt: 'Flying unicorn',
      style: unicornStyle,
    }),
  );
};

module.exports = Unicorn;
